export const BADGE_GAP = 4;

export function rowsForBadgeWidths(
  widths: number[],
  containerWidth: number
): number {
  if (widths.length === 0) return 0;
  let rows = 1;
  let rowWidth = 0;

  for (const width of widths) {
    if (rowWidth === 0) {
      rowWidth = width;
    } else if (rowWidth + BADGE_GAP + width <= containerWidth) {
      rowWidth += BADGE_GAP + width;
    } else {
      rows++;
      rowWidth = width;
    }
  }

  return rows;
}
